interface DataRowProps {
  label: string
  value: React.ReactNode
  valueClassName?: string
}

export default function DataRow({ label, value, valueClassName }: DataRowProps) {
  return (
    <div className="flex justify-between text-xs">
      <span className="text-pearl/50">{label}</span>
      <span className={valueClassName ?? 'text-pearl'}>{value}</span>
    </div>
  )
}
